import { render, staticRenderFns } from "./BookingFeatureList.vue?vue&type=template&id=1b159bc6"
import script from "./BookingFeatureList.js?vue&type=script&lang=js&external"
export * from "./BookingFeatureList.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports